import React from 'react';
import { 
  Box, 
  Card, 
  Flex, 
  Text, 
  Button, 
  Heading,
  Container,
  Separator,
  Badge,
  Code
} from '@radix-ui/themes';
import {
  PersonIcon,
  LockClosedIcon
} from '@radix-ui/react-icons';
import { useAuth } from '../contexts/AuthContext';

const Login: React.FC = () => {
  const { login } = useAuth();

  const handleLogin = () => {
    console.log('🔍 Starting Auth0 login via backend...');
    login();
  };

  return (
    <Box
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
      }}
    >
      <Container size="2" className="w-full max-w-md">
        <Card 
          size="4" 
          className="shadow-2xl"
          style={{
            background: 'rgba(255, 255, 255, 0.98)',
            backdropFilter: 'blur(10px)',
          }}
        >
          <Flex direction="column" gap="6">
            {/* Header Section */}
            <Box
              className="text-center p-6 rounded-t-lg text-white"
              style={{
                background: 'linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)',
              }}
            >
              <img
                src="/logo192.png"
                alt="Phanova Logo"
                width="64"
                height="64"
                className="mx-auto mb-3"
              />
              <Heading size="8" className="font-bold mb-2">
                Phanova
              </Heading>
              <Text size="4" className="opacity-90">
                Continuous Care Management
              </Text>
            </Box>

            <Box className="px-6 pb-6">
              {/* Welcome Section */}
              <Box className="text-center mb-6">
                <Heading size="6" className="mb-2 text-slate-800">
                  Welcome to Phanova
                </Heading>
                <Text size="3" className="text-slate-600 leading-relaxed">
                  Simplify and scale your chronic-care management.
                  <br />
                  Engage patients, track progress, and deliver measurable outcomes - 
                  <br />
                  all in one seamless platform.
                </Text>
              </Box>
              
              {/* Login Button */}
              <Button
                size="4"
                className="w-full text-lg font-semibold py-3"
                onClick={handleLogin}
                style={{
                  background: 'linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)',
                  color: 'white',
                  cursor: 'pointer'
                }}
              >
                <PersonIcon className="mr-2" />
                Login
              </Button>
            </Box>

          </Flex>
        </Card>
      </Container>
    </Box>
  );
};

export default Login;
